export default __webpack_public_path__ + "static/media/tie_7.53930950.mp3";